
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/licence-plate-renewal",
      function () {
        return require("private-next-pages/licence-plate-renewal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/licence-plate-renewal"])
      });
    }
  